<template>
  <div id="app" :class="[
    (bgcShow == 1 && bgcisshow1 == 0) || (bgcShow == 0 && bgcisshow1 == 0)
      ? 'bgc'
      : 'aaa',
  ]" v-cloak>
    <div class="logo-link" v-if="showBoXueGu">
      <img src="./assets/reset-pass/logo.png" alt="" @click="toHome" />
    </div>
    <div class="logo-link logo-link2" v-else>
      <img src="./assets/reset-pass/logoMatch.png" @click="toHomeMatch" alt=""/>
    </div>
    <router-view />
    <myToast v-show="manyloginToast"></myToast>
  </div>
</template>

<script>
import myToast from "./components/common/my-toast.vue";
import { getQueryString} from "@/utils/utils";
import("./utils/zhugeIO.js");
import { mapState } from "vuex";
export default {
  name: "App",
  data() {
    return {
      bgcShow: 1,
      showBoXueGu:true,
    };
  },
  computed: {
    ...mapState(["manyloginToast", "bgcisshow1"]),
  },
  components: {
    myToast,
  },
  mounted() {
    if (location.href.indexOf("toResetEmail") != -1) {
      this.bgcShow = 0;

    } else {
      this.bgcShow = 1;
    }
    if(window.location.search.indexOf('match')>-1){
      this.showBoXueGu=false
    }
    // 不是pc
    if(!this.IsPC()){
      let refer = getQueryString("refer")
      ? decodeURIComponent(getQueryString("refer"))
      : "";
      window.location.href = `${process.env.VUE_APP_BASE_PATH_H5}/loginRegister/phoneLogin?refer=${refer}`
    }
  },
  methods: {
    toHomeMatch(){
      window.location.href = process.env.VUE_APP_BASE_PATH_ONLINE+'/match'
    },
    toHome() {
      window.location.href = process.env.VUE_APP_BASE_PATH_ONLINE;
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 1280px) {
  .logo-link {
    margin: 60px 0 0 40px !important;
  }

  .register-cont {
    right: 120px !important;
  }
}

@media screen and (min-width: 1920px) {
  .logo-link {
    margin: 40px 0 0 60px !important;
  }

  .register-cont {
    right: 440px !important;
  }

  #app {
    background-position: left center !important;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1919px) {
  .logo-link {
    margin: 40px 0 0 60px !important;
  }

  .register-cont {
    right: 200px !important;
  }
}

[v-cloak] {
  display: none !important;
}

body,
html,
#app {
  width: 100%;
  height: 100%;
  color: #333;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;

  background-size: cover;
  position: relative;
  background-position: left top;

  .logo-link {
    margin: 60px 0 0 40px;

    img {
      width: 144px;
      height: 48px;
      cursor: pointer;
    }
  }
  .logo-link2 {
   
    img {
      width: 170px;
      height: 41px;
      cursor: pointer;
    }
  }
}

.bgc {
  background: url("./assets/reset-pass/reset-pass-bg.png") center center;
}

a,
h1,
h2,
h3,
h4,
h5,
h6,
p,
li,
ul,
ol,
pre {
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style: none;
  box-sizing: border-box;
}

.layer {
  min-width: 200px;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%);
  -moz-transform: translate(-50%);
  -ms-transform: translate(-50%);
  -o-transform: translate(-50%);
  transform: translate(-50%);
  z-index: 100001;
  text-align: center;
  border-radius: 8px;
}

.layer p {
  color: #ffffff;
  font-size: 14px;
  margin: 0;
  padding: 0;
}

.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  .el-dialog {
    margin-top: 0 !important;
  }
}

// 对话框
.el-dialog {

  // 弹框提示名称
  .el-dialog__header {
    padding: 24px 32px 10px !important;
    color: #1D2129 !important;
  }

  .el-dialog__body {
    padding: 22px 32px 32px !important;
  }

  // 弹框底部按钮
  .el-dialog__footer {
    padding: 10px 32px 32px !important;

    // 按钮
    .el-button {
      min-width: 80px;
      height: 32px;
      border-radius: 4px;
      padding: 9px 20px;
    }

    // 取消按钮
    .el-button--default {
      background: #F2F3F5;
      border: 0;
      color: #1D2129;

      &:hover {

        color: #1D2129 !important;
        background-color: #E5E6EB !important;
        border-color: #E5E6EB !important;
      }

      font-weight:normal;
    }

    // 确认按钮
    .el-button--primary {
      font-weight: normal;
      border: 0;
      color: #fff;
      background: #165DFF;

      &:hover {
        background: #4080FF;
      }
    }
  }

  .el-dialog__headerbtn .el-dialog__close {
    padding: 3px;
    border-radius: 4px;
    color: #86909C;
    font-weight: 600;
  }

  .el-dialog__headerbtn {
    position: absolute;
    top: 24px;
    right: 31px;
  }

  .el-dialog__headerbtn:focus .el-dialog__close,
  .el-dialog__headerbtn:hover .el-dialog__close {
    background: #F2F3F5;
    color: #86909C;
  }
}</style>
